<template>
  <svg
    data-v-3973e921=""
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  ><path
    d="M15 12.5L12 15.5L9 12.5"
    stroke="#B0B7C3"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  /><path
    d="M12 9L12 14"
    stroke="#B0B7C3"
    stroke-width="1.5"
    stroke-linecap="round"
  /><circle
    cx="12"
    cy="12"
    r="9"
    stroke="#B0B7C3"
    stroke-width="2"
  /></svg>
</template>